export default __webpack_public_path__ + "static/media/pizza.03422715.png";